import React from 'react';
import { WeekSelectionWrapper, TotalGrossContainer } from './weeklyReports';
import styles from './reports.module.scss';
import { priceOnFinish } from '../../supplementary_components/priceInputDelegate';
import * as XLSX from "xlsx";

export const WeeklyGrossByTeams = ({companyData, department}) => {
    const headerObject = ["Team Name", "Truck Count", "Average Gross Per Truck", "Total Gross"];
    return <WeekSelectionWrapper companyData={companyData} reportLink={'teams/weeklyGrossByTeams'} rowType={"clickable"} headerObject={headerObject} custoMreportClass={WeeklyTeamReport} rowFunction={TeamRowReport} SubContentPart={SubContentPart} subcontentArrayName={"trucks"} exportToXlsx={exportTeamTruckReportToXlsx} startWithPrevWeek={true} department={department} />
}
class WeeklyTeamReport{
    teamName;
    truckCount;
    averageGrossPerTruck;
    totalGross;
    constructor(report){
        this.teamName = report.teamName;
        let totalGross = 0;
        if(report.trucks){
            this.truckCount = report.trucks.length || 0;
            for (const truck of report.trucks){
                try {
                    totalGross += truck.totalGross;
                } catch (error) {  
                }
            }
        }else{
            this.truckCount = 0;
        }
        this.averageGrossPerTruck =   totalGross && this.truckCount ? (totalGross/this.truckCount).toFixed(2) : "-";
        this.totalGross = totalGross;
    }
}
const TeamRowReport = (key, singleReport, currentReport, selectedPeriod, setCurrentReport, department ) => {
     
    if(key === "totalGross"){
        return <div key={key} className={`${styles.hasCustomColor} ${styles.lastChild}`}><TotalGrossContainer  totalGross={singleReport.totalGross} /></div>
    }else if(key === "averageGrossPerTruck"){
        return <div key={key} className={`${singleReport.averageGrossPerTruck !== '-' ? styles.hasCustomColor : ''}`}><TotalGrossContainer  totalGross={singleReport.averageGrossPerTruck} /></div>

    }
    return <div key={key} className={styles[key]} >{singleReport[key]}</div>;
}
const SubContentPart = ({currentReport}) => {
    return <>{currentReport.trucks.map((truck, subIndex) => {
        return <div key={subIndex}>
            <div>{truck.truckNumber}</div>
            <div>{priceOnFinish(`${truck.totalGross}`, true)}</div>
        </div>
    })}</>
}
export async function exportTeamTruckReportToXlsx(metadata, data) {
    let filename = `Team Performance Report ${metadata.fileName.replace(/\//g, '.')}`;
    if(metadata.timeframe === 'monthly'){
        filename += ` ${metadata.startDate.slice(0, 4)}`;
    }
    filename += '.xlsx';
    try {
        const headers = [
        "Team Name",
        "Truck Count",
        "Average Gross Per Truck",
        "Total Gross",
        "Truck Number",
        "Truck Gross",
        ];

        const rows = [];

        for (const team of (data ?? [])) {
        const trucks = Array.isArray(team?.trucks) ? team.trucks : [];
        const truckCount = trucks.length;

        // If teamTotal is missing, compute it from trucks
        const computedTeamTotal = trucks.reduce((sum, t) => sum + (Number(t?.totalGross) || 0), 0);
        const teamTotal = Number(team?.teamTotal);
        const totalGross = Number.isFinite(teamTotal) ? teamTotal : computedTeamTotal;

        const avgGross = truckCount > 0 ? totalGross / truckCount : 0;

        // Ensure at least one row per team even if there are no trucks
        const list = truckCount ? trucks : [null];

        list.forEach((truck, idx) => {
            const teamFields = idx === 0
            ? [team?.teamName ?? "", truckCount, avgGross, totalGross]
            : ["", "", "", ""];

            const truckNumber = truck?.truckNumber ?? "";
            const truckGross  = Number(truck?.totalGross) || 0;

            rows.push([
            ...teamFields,
            truckNumber,
            truck ? truckGross : 0,
            ]);
        });
        }

        const aoa = [headers, ...rows];

        // Build worksheet
        const ws = XLSX.utils.aoa_to_sheet(aoa);

        // Column widths
        ws["!cols"] = [
        { wch: 22 }, // Team Name
        { wch: 12 }, // Truck Count
        { wch: 24 }, // Average Gross Per Truck
        { wch: 14 }, // Total Gross
        { wch: 14 }, // Truck Number
        { wch: 24 }, // Total Gross Of The Truck
        ];

        // Numeric formatting:
        // B = Truck Count (int), C = Avg Gross (currency), D = Team Total (currency), F = Truck Gross (currency)
        const lastRow = aoa.length; // includes header
        for (let r = 2; r <= lastRow; r++) {
        // B (Truck Count)
        const b = XLSX.utils.encode_cell({ r: r - 1, c: 1 });
        if (ws[b] && ws[b].v !== "") { ws[b].t = "n"; ws[b].z = "#,##0"; }

        // C (Average Gross Per Truck)
        const c = XLSX.utils.encode_cell({ r: r - 1, c: 2 });
        if (ws[c] && ws[c].v !== "") { ws[c].t = "n"; ws[c].z = "#,##0.00"; }

        // D (Total Gross)
        const d = XLSX.utils.encode_cell({ r: r - 1, c: 3 });
        if (ws[d] && ws[d].v !== "") { ws[d].t = "n"; ws[d].z = "#,##0.00"; }

        // F (Total Gross Of The Truck)
        const f = XLSX.utils.encode_cell({ r: r - 1, c: 5 });
        if (ws[f] && ws[f].v !== "") { ws[f].t = "n"; ws[f].z = "#,##0.00"; }
        }

        // Workbook + download
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Team Trucks");

        const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const blob = new Blob([wbout], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        await new Promise(res => setTimeout(res, 100));
        URL.revokeObjectURL(url);

        return true;
    } catch (err) {
        console.error("Failed to export Team Truck XLSX:", err);
        return false;
    }
}